import {BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import SignIn from './pages/users/SignIn'
import SignUp from './pages/users/SignUp'
import routes from './pages/Routes'
import ForgotPassword from './pages/users/ForgotPassword'
import Otp from './pages/users/Otp'
import ChangePassword from './pages/users/ChangePassword'
import Home from './pages/Home'
import Movie from './pages/Movie'
import TVShows from './pages/TVShows'
import GenreswiseMovie from './pages/GenreswiseMovie'
import GenreswiseTvshow from './pages/GenreswiseTvshow'
import Watchlist from './pages/Watchlist'
import SwitchProfile from './pages/SwitchProfile'
import AccountSetting from './pages/AccountSetting'
import AccountChangePassword from './pages/AccountChangePassword'
import BillingDetails from './pages/BillingDetails'
import Plans from './pages/Plans'
import Payment from './pages/Payment'
import ViewAll from './pages/ViewAll'
import Landing from './pages/Landing'
import Protected from './Protected'
import SelectGenres from './pages/SelectGenres'
import VideoPlay from './pages/VideoWatch'
import SearchData from './pages/SearchData'
import PageNotFound from './pages/NotFound'
import ViewAllTvshow from './pages/ViewAllTVshow'
import Viewallhome from './pages/Viewallhome'
import Active from './pages/users/Active'
import Privacy from './pages/Privacy'
import ComingSoon from './pages/ComingSoon'
import { useEffect, useState } from 'react'
import { API_URLS, API_URL_BASE } from './pages/utils'
import { Session, User, UserCountry } from './pages/Helper'
import secureLocalStorage from 'react-secure-storage'
import CloseAcccount from './pages/CloseAcccount'

export default function App() {

  const [UserLogin, setUserLogin] = useState("");

  var user = User();
  const token = user?.data.token
  var session = Session();
  const sessionCountry = UserCountry();

  const [ipAddress, setIpAddress]     = useState(null);
  

  useEffect(() => {


    fetch(`${API_URL_BASE}${API_URLS.FEATURES_LIST}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-type": "application/json",
        },

    }).then((result) => {

        result.json().then((resp) => {
            if(resp.response == true) {
              setUserLogin(resp.data.login);
            } 
        })
    })
    

    /* Fetching User Ip Addres And Country*/
    if(sessionCountry == null){
        const fetchIpAddress = async () => {
            try {
            const response = await fetch('https://api.ipify.org?format=json');
            if (!response.ok) {
                throw new Error('Failed to fetch IP address');
            }
            const data = await response.json();
            setIpAddress(data.ip);
            } catch (error) {
            console.error('Error fetching IP address:', error);
            }
        };
  
        fetchIpAddress();
        
        if(ipAddress){  
            fetch(`http://ipwho.is/${ipAddress}`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                
            })
            .then((result) => {
                if (!result.ok) {
                    throw new Error(`HTTP error! Status: ${result.status}`);
                }
                return result.json();
            })
            .then((resp) => {
                secureLocalStorage.setItem("user-country",JSON.stringify(resp.country_code));
            })
            .catch((error) => {
                console.error("Error fetching user location:", error);
            });
        }   
    }

  });

  const loggedInRoutes = (
        <>
          <Route path={routes.watchlist} element={<Protected Component={Watchlist} />}></Route>
          <Route path={routes.switchProfile} element={<Protected Component={SwitchProfile} />}></Route>
          <Route path={routes.accountSetting} element={<Protected Component={AccountSetting} />}></Route>
          <Route path={routes.accountChangePassword} element={<Protected Component={AccountChangePassword} />}></Route>
          <Route path={routes.billingDetails} element={<Protected Component={BillingDetails} />}></Route>
          <Route path={routes.plans} element={<Protected Component={Plans} />}></Route>
          <Route path={routes.payment} element={<Protected Component={Payment} />}></Route>

          <Route path={"/"} element={<Protected Component={Landing} />}></Route>
          <Route path={routes.home} element={<Protected Component = {Home}/>}></Route>
          <Route path={routes.movie} element={<Protected Component = {Movie}/>}></Route>
          <Route path={routes.tvShows} element={<Protected Component = {TVShows}/> }></Route>
          <Route path={routes.viewAll} element={<Protected Component = {ViewAll}/>}></Route>
          <Route path={routes.viewAllhome} element={<Protected Component = {Viewallhome}/>}></Route>
          <Route path={routes.viewAllRTVshow} element={<Protected Component = {ViewAllTvshow}/>}></Route>
          <Route path={routes.genresmovie} element={<Protected Component = {GenreswiseMovie} />}></Route>
          <Route path={routes.genrestvshow} element={<Protected Component = {GenreswiseTvshow} />}></Route>
          <Route path={routes.selectGenres} element={<Protected Component = {SelectGenres}/>}></Route>
          <Route path={routes.SearchData} element={<Protected Component = {SearchData}/>}></Route>
          <Route path={routes.VideoWatch} element={<Protected Component = {VideoPlay} />}></Route>
          <Route path={routes.closeAccount} element={<Protected Component = {CloseAcccount} />}></Route>
          <Route path={routes.signin} element={<SignIn/>}></Route>
          <Route path={routes.signup} element={<SignUp/>}></Route>
          <Route path={routes.forgot} element={<ForgotPassword/>}></Route>
          <Route path={routes.otp} element={<Otp/>}></Route>
          <Route path={routes.changePassword} element={<ChangePassword/>}></Route>
          <Route path={routes.activeAccount} element={<Active/>}></Route>
          <Route path={routes.Privacy} element={<Privacy/>}></Route>
          <Route path={routes.NotFound} Component={PageNotFound}></Route>
          <Route path={routes.comingSoon} element={<ComingSoon/>}></Route>
          


        </>
  );

const nonLoggedInRoutes = (
        <>
          <Route path={"/"} element={<Landing/>}></Route>
          <Route path={routes.home} element={<Home/>}></Route>
          <Route path={routes.movie} element={<Movie/>}></Route>
          <Route path={routes.tvShows} element={<TVShows/> }></Route>
          <Route path={routes.viewAll} element={<ViewAll/>}></Route>
          <Route path={routes.viewAllhome} element={<Viewallhome/>}></Route>
          <Route path={routes.viewAllRTVshow} element={<ViewAllTvshow/>}></Route>
          <Route path={routes.genresmovie} element={<GenreswiseMovie />}></Route>
          <Route path={routes.genrestvshow} element={<GenreswiseTvshow />}></Route>
          <Route path={routes.selectGenres} element={<SelectGenres/>}></Route>
          <Route path={routes.SearchData} element={<SearchData/>}></Route>
          <Route path={routes.VideoWatch} element={<VideoPlay />}></Route>  
          
          <Route path={routes.signin} element={<SignIn/>}></Route>
          <Route path={routes.signup} element={<SignUp/>}></Route>
          <Route path={routes.forgot} element={<ForgotPassword/>}></Route>
          <Route path={routes.otp} element={<Otp/>}></Route>
          <Route path={routes.changePassword} element={<ChangePassword/>}></Route>
          <Route path={routes.activeAccount} element={<Active/>}></Route>
          <Route path={routes.Privacy} element={<Privacy/>}></Route>
          <Route path={routes.NotFound} Component={PageNotFound}></Route>
          <Route path={routes.comingSoon} element={<ComingSoon/>}></Route>
          
          <Route path={routes.watchlist} element={<Protected Component={Watchlist} />}></Route>
          <Route path={routes.switchProfile} element={<Protected Component={SwitchProfile} />}></Route>
          <Route path={routes.accountSetting} element={<Protected Component={AccountSetting} />}></Route>
          <Route path={routes.accountChangePassword} element={<Protected Component={AccountChangePassword} />}></Route>
          <Route path={routes.billingDetails} element={<Protected Component={BillingDetails} />}></Route>
          <Route path={routes.plans} element={<Protected Component={Plans} />}></Route>
          <Route path={routes.payment} element={<Protected Component={Payment} />}></Route>
          <Route path={routes.closeAccount} element={<Protected Component = {CloseAcccount} />}></Route>
        </>
);

  return (
      <div>
       <Routes>
      {UserLogin || token || session ?(loggedInRoutes) :(nonLoggedInRoutes)}
      </Routes>
      </div>
  )
}

